module.exports = __webpack_public_path__ + "img/benefits-05.059a9d7b.png";